let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h97Cj")).then(() => parcelRequire('ekKS8'));